import { useEffect } from "react"
import { useMap } from "react-leaflet"
import _ from 'lodash'
function FlyMapTo({ position, dataMemo, mapRange }) {
    const map = useMap()
    useEffect(() => {
        if (mapRange) {
            const final = 15 - _.parseInt(mapRange.radius) ?? 3
            // console.log(final)
              map.setZoom(final)
        }
        map.flyTo(position)
    }, [position, mapRange])

    return null
}
export default FlyMapTo;